function Empty({ children }: any) {
  return children;
}

export default Empty;
